import React  from 'react';
import CodeMngTemplate from '../../components/codemng/CodeMngTemplate';
import BreadcrumbsContainer from '../../containers/common/breadcurmbs/BreadcrumbsContainer';



const CodeMngPage = () => {
  return (
    <div>
      <BreadcrumbsContainer title="공통관리/공통코드관리/공통코드 리스트" icon="common"/>
      <CodeMngTemplate/>
    </div>
  );
};

export default CodeMngPage;
